import service from "services/maintenance/loanTypeService";
import { RealEstateAgentOutlined } from "@mui/icons-material";
import MAINTENANCE_STORE_SELECTORS from "features/maintenance/dataStore/selectors";

const loanTypeResource = {
    title: "Loan Types",
    singular: "Loan Type",
    displayField: "description",
    service: service,
    pageIcon: RealEstateAgentOutlined,
    setter: MAINTENANCE_STORE_SELECTORS.LOAN_TYPE,

    columns: [
        {
            field: "loanTypeCode",
            header: "Loan Type",
            width: "15%"
        },
        {
            field: "description",
            header: "Description"
        },
        {
            field: "deductionSchedule",
            header: "Deduction Schedule"
        },
        {
            field: "createdByName",
            header: "Created By",
            width: "15%"
        },
        {
            field: "updatedByName",
            header: "Updated By",
            width: "15%"
        }
    ],
    fields: [
        {
            name: "loanTypeCode",
            label: "Loan Type",
            type: "text",
            required: true,
            unique: true
        },
        {
            name: "description",
            label: "Description",
            type: "text",
            required: true
        },
        {
            name: "deductionSchedule",
            label: "Deduction Schedule",
            type: "select",
            required: true,
            options: [
                { value: "1st Half", label: "1st Half" },
                { value: "2nd Half", label: "2nd Half" },
                { value: "Semi-Monthly", label: "Semi-Monthly" },
                { value: "Weekly", label: "Weekly" }
            ]
        }
    ],
    searchFields: ["loanTypeCode", "description"]
};

export default loanTypeResource;
